import { Component } from '@angular/core';
import { AbstractAdvancedInput } from '../abstract-advanced-input';

@Component({
  selector: 'miq-naics-input',
  template: `
    <miq-record-naics-input
      [currentValue]="value"
      (currentValueChange)="change($event)"
      [recordDetail]="configuration"
      [disabled]="configuration.isDisabled"
    ></miq-record-naics-input>
  `,
  standalone: false,
})
export class AdvancedNaicsInputComponent extends AbstractAdvancedInput {
  change({ value }: { value: any }) {
    this.value = value;
  }
}
